const discoveryUrl = "https://kcmgpb2cdev.b2clogin.com/kcmgpb2cdev.onmicrosoft.com/c765b4b7-179d-4ed3-8116-660a6fdf6495/v2.0/.well-known/openid-configuration?p=b2c_1_opus_signupsignin"

export const environment = {
  production: false,
  apiUrl: 'https://api-dev.gpe16-17.keolis-idf.com/api/v1/opus',
  discoveryUrl: discoveryUrl,
  issuerNameB2c: 'kcmgpb2cdev.b2clogin.com',
  issuerNameOnMicrosoft: 'kcmgpb2cdev.onmicrosoft.com',
  subscriptionKey: '884d8213295347d9bfe896603145890b',
  idp: {
    issuer: "https://kcmgpb2cdev.b2clogin.com/c765b4b7-179d-4ed3-8116-660a6fdf6495/v2.0/",
    redirectUri: window.location.origin + "/",
    clientId: "0d3f2149-c24e-4898-9ebf-534d3de79cd5",
    scope: `openid profile email offline_access`,
    responseType: "code",
    showDebugInformation: true,
    //requireHttps: false,
    strictDiscoveryDocumentValidation: false,
    postLogoutRedirectUri: window.location.origin + "/",
    tokenEndpoint: "https://kcmgpb2cdev.b2clogin.com/kcmgpb2cdev.onmicrosoft.com/oauth2/v2.0/token?p=b2c_1_opus_signupsignin",
  },
};

